import { create } from "zustand";

interface HookProps {
  open: boolean;
  checkinId: string;
  setCheckinId: (id: string) => void;
  onOpenChange: (open: boolean) => void;
}

export const useCheckinModal = create<HookProps>()((set) => ({
  open: false,
  checkinId: "",
  setCheckinId: (id) =>
    set(() => ({
      checkinId: id,
    })),
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
